/*
  Keeps the per-variant delivery line in sync with the variant picker.

  Dawn already refetches the whole main-product section for the newly selected
  variant and publishes it as PUB_SUB_EVENTS.variantChange. product-info.js
  copies price, Sku and Inventory out of that HTML but ignores custom Liquid
  blocks, which is why the delivery line used to sit frozen.

  This does the same copy for our line. All the logic about what counts as
  in stock lives in snippets/ws-pdp-trust.liquid and is rendered server-side.
  Nothing here knows or decides anything, it only moves text.

  If this never runs, the line stays correct for the variant the page loaded
  with, which was the behaviour before this file existed.
*/
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data || !data.html) return;
    const id = `WsDispatch-${data.sectionId}`;
    const source = data.html.getElementById(id);
    const destination = document.getElementById(id);
    if (source && destination) destination.innerHTML = source.innerHTML;
  });
});
